import Masonry from "masonry-layout";
import imagesLoaded from "imagesloaded";

export default function initMasonry() {
  const isPresent = document.querySelector(".masonry-grid");
  if (!isPresent) {
    return;
  }

  var grid = document.querySelector(".masonry-grid");

  imagesLoaded(document.querySelector(".masonry-grid"), function (instance) {
    var msnry = new Masonry(grid, {
      itemSelector: ".masonry-grid__item",
    });
  });
}
